import { APICore } from "helpers/api/apiCore";
import config from "../../../config";
import { CreateChargeSettlement } from "./types";

const api = new APICore();

function fetchChargeSettlementsApi(params: any) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-charge-settlement`;

  return api.get(`${baseUrl}`, params);
}

function fetchChargeSettlementByExternalIdApi(params: any) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-charge-settlement/${params?.externalId}`;
  return api.get(`${baseUrl}`, params);
}

function fetchChargeSettlementAuditActionsApi(params: any) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/action-audit`;
  return api.get(`${baseUrl}`, params);
}

function createChargeSettlementApi(params: CreateChargeSettlement) {
  const apiData = {
    chargeId: params?.chargeId,
    amount: params?.amount,
    settlementDate: params?.settlementDate,
    comment: params?.comment,
    utr: params?.utr,
    chargeBaseType: params?.chargeBaseType,
    makerRemarks: params?.makerRemarks
  };

  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-charge-settlement/create`;
  return api.create(`${baseUrl}`, apiData);
}

function approveChargeSettlementApi(params: any) {
  const apiData = {
    checkerRemarks: params?.values?.checkerRemarks
  };

  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-charge-settlement/${params.id}/approve`;

  return api.updatePatch(`${baseUrl}`, apiData);
}

function rejectChargeSettlementApi(params: any) {
  const apiData = {
    checkerRemarks: params?.values?.checkerRemarks
  };

  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-charge-settlement/${params.id}/reject`;

  return api.updatePatch(`${baseUrl}`, apiData);
}

export { fetchChargeSettlementByExternalIdApi, fetchChargeSettlementsApi, fetchChargeSettlementAuditActionsApi, createChargeSettlementApi, approveChargeSettlementApi, rejectChargeSettlementApi };
